import localScaleManager from "../../helpers/LocalScaleManager";
import Button from "./objects/button";

export class Modal {
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;
    this.overlay = this.scene.add.rectangle(0, 0, 0, 0, 0x000000);
    if (this.table) this.table.poolArray.push(this.overlay);
    this.overlay.setAlpha(0);
    this.overlay.setDepth(100);
    // this.closeButton = this.scene.add.image(0, 0, this.scene.atlasTexture, "x");
    this.closeButton = new Button(scene, "x", true);
    this.closeButton.setOrigin(0.5);
    // this.closeButton.setInteractive({cursor: 'pointer'});
  }
  modalShow() {
    this.scene.changeObjectsInteractivity(false);
    this.overlay.setX(
      this.scene.getVisitedTableGameIndex() * this.overlay.width
    );
    this.scene.tweens.add({
      targets: this.overlay,
      duration: 50,
      ease: "Linear",
      alpha: 0.5,
      // width: this.scene.gameWidth,
      // height: this.scene.gameHeight,
      onComplete: () => {},
    });
  }
  modalHide() {
    this.scene.changeObjectsInteractivity(true);
    this.scene.tweens.add({
      targets: this.overlay,
      duration: 50,
      ease: "Linear",
      alpha: 0,
    });
  }
  positionControls(modalX, modalY, modalWidth) {
    this.overlay.width = this.scene.gameWidth;
    this.overlay.height = this.scene.gameHeight;
    this.overlay.setPosition(
      this.scene.getVisitedTableGameIndex() * this.overlay.width,
      0
    );
    // this.overlay.setPosition(this.scene.gameWidth / 2, this.scene.gameHeight / 2)
    const closeButtonSize = modalWidth / 15;
    localScaleManager.scaleSprite(
      this.closeButton,
      closeButtonSize,
      closeButtonSize,
      0,
      1,
      true
    );
    this.closeButton.setPosition(
      modalX + (modalWidth - this.closeButton.displayWidth * 2.5),
      modalY + this.closeButton.displayHeight
    );
    this.overlay.setInteractive();
  }
  reposition(modalX, modalY, modalWidth) {
    this.overlay.setPosition(
      this.scene.getVisitedTableGameIndex() * this.overlay.width,
      0
    );
    this.closeButton.setPosition(
      modalX + (modalWidth - this.closeButton.displayWidth * 2.5),
      modalY + this.closeButton.displayHeight
    );
  }
  remove() {
    this.overlay.destroy();
    this.closeButton.destroy();
  }
}
